import { MissionData } from '../types';
import { useAppStore } from '../../../../store/appStore';
import { useMemo } from 'react';
import { determineIsMissionCompleted } from '../helpers/completion';

export const useCompletedMissionCount = () => {
  const { missions } = useAppStore();

  return useMemo(() => {
    let completedMissionCount = 0;

    missions?.forEach((customer) => {
      customer.sites.forEach((site) => {
        const scheduledDates = new Set<string>();

        site.scheduledFlights.forEach((schedule) => {
          const date = schedule.flightDateIso;
          scheduledDates.add(date);
          const gcpPlacementService = site.gcpPlacementServices.find((gcp) => gcp.servicesPerformedDateIso === date);
          const mission: MissionData = { customer, site, schedule, gcpPlacementService };
          if (determineIsMissionCompleted(mission)) {
            completedMissionCount++;
          }
        });

        site.gcpPlacementServices.forEach((gcpPlacementService) => {
          const date = gcpPlacementService.servicesPerformedDateIso;
          if (!date) return;
          if (scheduledDates.has(date)) return;
          scheduledDates.add(date);
          const mission: MissionData = { customer, site, gcpPlacementService };
          if (determineIsMissionCompleted(mission)) {
            completedMissionCount++;
          }
        });
      });
    });

    return completedMissionCount;
  }, [missions]);
};
